<template>
  <div class="mcoupon-list qw-dislist">
    <div class="qd-container">
      <van-sticky>
        <div class="qd-head">
          <van-button icon="add-o" type="info" @click="addDis"
            >创建一个新的活动</van-button
          >
        </div>
      </van-sticky>

      <div class="qd-list">
        <van-list
          v-model="data.loading"
          :finished="data.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="qd-item"
            v-for="(item, index) in data.datas"
            :key="index"
            @click="goQrcode(item.coupon_id)"
          >
            <!-- <van-icon name="qr" /> -->
            &nbsp;{{ item.pub_title }}
            <van-tag type="primary" v-if="item.coupon_used"
              >新增好友{{ item.coupon_used }}人</van-tag
            >
            <van-tag mark v-if="item.coupon_status == 0">已停止</van-tag>
            <van-icon
              v-if="!item.loading"
              name="ellipsis"
              class="qd-item-settle"
              @click.stop="itemMenuEvent(index)"
            />
            <van-loading class="qd-item-loading" v-if="item.loading" />
          </div>
        </van-list>
      </div>
      <div class="mb-tab"></div>
    </div>
    <van-action-sheet
      v-model="itemmenu_show"
      :actions="itemmenu_action"
      cancel-text="取消"
      @select="onItemMenuSelect"
      @cancel="onItemMenuCancel"
    />

    <div class="right-tool">
      <div
        :class="'tool-help' + (showhelptext ? ' active' : '')"
        @click="goHelp"
      >
        <van-icon name="question" />
        <span class="text">查看帮助</span>
      </div>
    </div>

    <!-- 帮助页面 -->
    <van-popup
      v-model="showhelp"
      position="bottom"
      :style="{ height: '90%' }"
      closeable
    >
      <lu_actiondetail :noadd="1" :moduleid="4"></lu_actiondetail>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";

import ptypes from "../../producttype";
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import lu_actiondetail from "../ActionDetail.vue";

import {
  Button,
  List,
  Cell,
  CellGroup,
  Icon,
  Sticky,
  ActionSheet,
  Dialog,
  Toast,
  Tag,
} from "vant";
Vue.use(Button);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Tag);
export default {
  name: "console_index",
  data() {
    return {
      data: {
        page: 1,
        channeltype: 0,
        datas: [],
        loading: false,
        finished: false,
      },
      list: {
        datas: [],
        page: 1,
      },
      itemmenu_show: false,
      itemmenu_action: [
        { name: "编辑" },
        { name: "停用" },
        { name: "新用户数据" },
      ],
      itemmenu_index: 0,
      corpinfo: null,

      showhelptext: false,
      showhelp: false,

      ptypes: ptypes,
    };
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {},
  methods: {
    goHelp() {
      if (this.showhelptext) this.showhelp = true;
      this.showhelptext = !this.showhelptext;
    },
    //取消显示菜单
    onItemMenuCancel() {
      this.itemmenu_show = false;
    },
    //启用or停用
    enableItem(index, status) {
      var t = this;
      t.itemmenu_show = false;
      var channel = t.data.datas[t.itemmenu_index];
      t.data.datas[t.itemmenu_index].loading = true;
      setTimeout(() => {
        t.$http
          .post(
            "/Coupon/EnableCoupon",
            { coupon_id: channel.coupon_id, isenabled: status ?1:0},
            2
          )
          .then((res) => {
            t.data.datas[t.itemmenu_index].loading = false;
            t.data.datas[t.itemmenu_index].coupon_status = (status?0:1);
          })
          .catch((error) => {
            t.data.datas[t.itemmenu_index].loading = false;
            Toast("网络异常，请稍后重试");
          });
      }, 100);
    },
    //选择某个菜单
    onItemMenuSelect(item) {
      var t = this;
      var channel = t.data.datas[t.itemmenu_index];
      console.log("item", item);
      switch (item.name) {
        case "编辑":
          t.editDis(channel.coupon_id);
          break;
        case "新用户数据":
          t.getCouponUsers(channel.coupon_id);
          break;
        case "删除":
          t.delDis(t.itemmenu_index);
          break;
        case "停用":
          t.enableItem(t.itemmenu_index, true);
          break;
        case "启用":
          t.enableItem(t.itemmenu_index, false);
          break;
        default:
          break;
      }
    },
    //每个项的点击菜单
    itemMenuEvent(index) {
      var t = this;
      t.itemmenu_index = index;
      var item = t.data.datas[t.itemmenu_index];
      if (item.coupon_status == 0) t.itemmenu_action[1].name = "启用";
      else t.itemmenu_action[1].name = "停用";
      t.itemmenu_show = true;
    },
    //添加
    async addDis() {
      var t = this;
      var product = await this.checkProductNo([
        ptypes.好友裂变,
        ptypes.超级拓展包,
        ptypes.专业版,
      ]);
      if (!product) {
        this.$AskBuy("此项属于付费模块，您需要先升级");
        return;
      }
      t.$router.push({
        path: "/mcoupon/detail1",
        query: {},
      });
    },
    //编辑
    editDis(id) {
      var t = this;
      t.$router.push({
        path: "/mcoupon/detail1",
        query: { couponid: id },
      });
    },

    getCouponUsers(id) {
      var t = this;
      t.$router.push({
        path: "/mcoupon/users",
        query: { id: id },
      });
    },
    //删除渠道
    delDis(index) {
      var t = this;
      Dialog.confirm({
        title: "系统提示",
        message: "确认删除该渠道么吗？",
      })
        .then(() => {
          t.itemmenu_show = false;
          var channel = t.data.datas[t.itemmenu_index];
          var loading = Toast.loading({
            message: "加载中...",
            forbidClick: true,
          });
          t.$http
            .post("/Coupon/DelCoupon", { channelid: channel.channelid }, 2)
            .then((res) => {
              loading.clear();
              t.data.datas.splice(t.itemmenu_index, 1);
            })
            .catch((error) => {
              loading.clear();
              Toast("网络异常，请稍后重试");
            });
        })
        .catch(() => {});
    },

    goQrcode(id) {
      var t = this;
      t.$router.push({
        path: "/mcoupon/info1",
        query: { id: id },
      });
      // t.GetBindCorp(() => {
      //   if (t.corpinfo)
      //     t.$router.push({
      //       path: "/mcoupon/info",
      //       query: { id: id },
      //     });
      //   else
      //     Dialog.alert({
      //       message:
      //         "尚未绑定微信服务号，无法生成活动参与二维码。\r\n\r\n首次使用冲榜裂变功能，需要您的微信服务号授权伙伴猫，请点击下方按钮进入授权设置",
      //       confirmButtonText: "马上授权",
      //       showCancelButton: true,
      //       messageAlign: "left",
      //     })
      //       .then(() => {
      //         t.$router.push({
      //           path: "/set/wpubstep1",
      //         });
      //       })
      //       .catch(() => {});
      // });
    },
    onLoad() {
      var t = this;
      console.log("onLoad", t.data.page);
      t.data.loading = true;
      t.$http
        .get(
          "/Coupon/GetCoupons",
          { pageindex: t.data.page, pagesize: 15, coupon_type: 2 },
          2
        )
        .then((res) => {
          t.data.loading = false;
          if (res.resultState == 1) {
            for (let index = 0; index < res.Data.datas.length; index++) {
              const element = res.Data.datas[index];
              element.loading = false;
            }
            t.data.datas = t.data.datas.concat(res.Data.datas);
            t.data.page += 1;
            if (res.Data.datas.length < 15) t.data.finished = true;
          } else {
            t.data.finished = true;
            Toast(res.errorMsg);
          }
          console.log("t.data.finished", t.data.finished);
        })
        .catch((error) => {});
    },

    //获得当前账号绑定的公众号信息
    GetBindCorp(callback) {
      var t = this;
      var url = `/user/GetBindCorp`;
      var params = {};
      t.corpinfo = null;
      t.$http
        .get(url, params, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.corpinfo = res.Data;
          } else {
          }
          typeof callback == "function" && callback();
        })
        .catch((error) => {
          console.log(error);
          typeof callback == "function" && callback(error);
        });
    },

    ...mapActions([
      "getFirmInfoAsync",
      "GetFirmVersionAsync",
      "checkProductNo",
    ]),
  },
  components: { lu_actiondetail },
  computed: {},
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss" src="../../../static/scss/dislist.scss"></style>
<style scoped lang="scss"></style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
